<template>
    <f7-page>
        <f7-navbar :title="pack.name" back-link="返回">
            <f7-nav-right @click="showTaskInfo">
                <div @click="showTaskInfo">
                    <f7-icon f7="download">
                        <f7-badge v-if="process.hasTask" color="green">1</f7-badge>
                    </f7-icon>
                </div>
            </f7-nav-right>
        </f7-navbar>
        <section class='detail_banner'>
            <img :src="mediaUrl()" class="goods_img goods_banner" alt="">
        </section>
        <section class="wrap">
            <section class="pack_detail">
                <div class="title">{{pack.iname}}</div>
                <div class="desc">{{pack.desc}}</div>
            </section>
            <section class="detailcontainer">
                <header class="header">商品详情</header>
                <div>
                    <img v-if="pack.image2" :src="pack.image2" alt="" class='width-100'>
                    <img v-if="pack.image3" :src="pack.image3" alt="" class='width-100'>
                    <img v-if="pack.image4" :src="pack.image4" alt="" class='width-100'>
                </div>
            </section>
        </section>
        <div slot="fixed">
            <div class='download-wrap'>
                <div class='download' @click="downLoadPack(pack)">下载</div>
            </div>
        </div>
    </f7-page>
</template>

<script type="text/ecmascript-6">
  import {
    f7Page,
    f7Link,
    f7Toolbar,
    f7Tabs,
    f7Tab,
    f7Button,
    f7Row,
    f7Col,
    f7NavRight,
    f7Icon,
    f7Badge,
    f7Swiper,
    f7SwiperSlide
  } from 'framework7-vue'
  import { globalConst as native } from '../../lib/const'
  import { getMediaUrl } from 'lib/common'
  import downLoadMixin from 'mixins/downLoadMixin'
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        pack: {},
        packId: -1
      }
    },
    mixins: [downLoadMixin],
    created () {
      this.packId = this.$f7route.params.id
      this.$store.dispatch({
        type: native.resDetail,
        id: this.packId
      }).then(({data}) => {
        this.pack = data
      })
    },
    methods: {
      mediaUrl () {
        return `${this.pack.mediaUrl}?x-oss-process=image/resize,w_375`
      },
      showTaskInfo () {
        if (this.process.hasTask) {
          this.$f7.notification.create({
            icon: '<i class="icon demo-icon"></i>',
            title: '当前下载任务',
            subtitle: `${this.process.fileName} 正在下载中...`,
            text: '当前进度' + this.process.value + '%',
            closeTimeout: 3000,
          }).open()
        }
      },
    },
    computed: {
      ...mapState({
        process: ({downLoader}) => downLoader.process
      })
    },
    destroyed () {
    },
    components: {
      f7Page,
      f7Link,
      f7Toolbar,
      f7Tabs,
      f7Tab,
      f7Button,
      f7Row,
      f7Col,
      f7NavRight,
      f7Icon,
      f7Badge,
      f7Swiper,
      f7SwiperSlide
    }
  }
</script>
<style lang="scss" scoped type="text/css">
    @import "../../css/packageDetail.scss";
</style>
